var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenCheck = function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.6 15.2 0C8.3 2 4.8 6.4 4.8 6.4L1.6 4 0 5.6 4.8 12C8.5 5.1 16 1.6 16 1.6Z",
    fill: "#00B67A"
  })));
};
export default SvgGreenCheck;